import React, { Component } from 'react';
import { Checkbox } from 'semantic-ui-react';
import { formValueSelector, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import moment from 'moment';
import _ from 'lodash';
import PropTypes from 'prop-types';

import { DATE_FORMAT_FOR_UI, DATE_FORMAT_FOR_SERVER } from 'Common/Constants';
import { UPDATE_OPEN_ORDERS_FORM_NAME } from 'Common/FormEnum';
import { UpdateOpenOrdersEnum } from 'Common/FieldEnum';
import {
  TypeEnum,
  ColumnHeaders,
  UpdateOpenOrderTypeEnum,
  TypeOptionEnum,
  InitialValuesEnum,
  OrderTypeEnum,
} from 'Common/Constants/Enumeration/UpdateOpenOrderEnum';
import { ReactTableWrapperColumnProperties } from 'Common/Constants';
import { makeOptionsDataRemoveEmpty } from 'Common/FormHelper';
import { resetForm } from 'State/forms/actions';
import EditableLabel from 'Components/editableLabel/EditableLabel';
import { actions } from '../../state/actions';
import { getSiteGroupOptionsData } from '../../helper/updateOpenOrders';
import UpdateOpenOrderComponent from './../components/UpdateOpenOrder';
import * as Selectors from '../../state/updateopenorders/selectors';

class UpdateOpenOrderDetailsContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      itemsToBeRemoved: false,
      itemsToBeAdded: false,
      selectedItemToRemove: null,
      selectedItemToAdd: null,
      selectedDeliveryDT: moment().format(DATE_FORMAT_FOR_UI),
      isTypeOptionSelected: TypeEnum.OpenOrders,
      columns: this.getStateColumns(),
      qtyPerUnit: 0,
      unitValue: '',
      secondaryUnitValue: '',
      showDialog: false,
      removeItemSecUnit: '',
      removeItemPriUnit: '',
      removeItemQtyPerUnit: 0,
      selectedItem: '',
      activeIndexForFilter: 0,
      filtered: [],
      sorted: [],
    };
  }

  static propTypes = {
    onSubmit: PropTypes.func,
    reactTableRef: PropTypes.object,
    openOrderDetailData: PropTypes.array.isRequired,
    siteGroupData: PropTypes.array.isRequired,
    warehouseKitchenData: PropTypes.array.isRequired,
    itemList: PropTypes.array.isRequired,
    loading: PropTypes.bool.isRequired,
    isFetchingItemList: PropTypes.bool.isRequired,
    isFetchingSiteGroup: PropTypes.bool.isRequired,
    submitting: PropTypes.bool.isRequired,
    totalPrimary: PropTypes.number.isRequired,
    totalSecondary: PropTypes.number.isRequired,
    totalRemaining: PropTypes.string.isRequired,
    WarehouseAvlbQuantity: PropTypes.number.isRequired,
    isTotalExceed: PropTypes.bool.isRequired,
    kitchenData: PropTypes.array.isRequired,
  };

  static defaultProps = {
    onSubmit: () => {},
    reactTableRef: null,
  };

  getStateColumns = () => {
    return [
      {
        Header: currentRows => {
          const allowedData = _.filter(
            this.props.openOrderDetailData,
            UpdateOpenOrdersEnum.Allowed
          );
          const dataObjs = currentRows.data;
          let filteredData = [];
          _.forEach(dataObjs, obj => {
            const id = obj[UpdateOpenOrdersEnum.OrderNumber]
              ? obj[UpdateOpenOrdersEnum.OrderNumber]
              : obj._original[UpdateOpenOrdersEnum.OrderNumber];
            const row = _.find(allowedData, v => v.OrderNumber === id);
            if (row) {
              filteredData.push(row);
            }
          });

          return (
            <div style={{ textAlign: 'center' }}>
              <Checkbox
                tabIndex={-1}
                checked={Boolean(
                  filteredData &&
                    filteredData.length &&
                    filteredData.length === dataObjs.length
                )}
                onChange={(e, data) => {
                  e.preventDefault();
                  e.stopPropagation();
                  this.props.checkAllRow(data.checked, currentRows.data);
                }}
              />
            </div>
          );
        },
        accessor: UpdateOpenOrdersEnum.Allowed,
        ...ReactTableWrapperColumnProperties,
        visibility: false,
        sortable: false,
        filterable: false,
        Filter: this.filterData,
        Cell: ({ original }) => {
          return (
            <div style={{ textAlign: 'center' }}>
              <Checkbox
                checked={original.Allowed}
                tabIndex={-1}
                onChange={() => {
                  this.props.checkCurrentRow(original);
                }}
              />
            </div>
          );
        },
      },
      {
        Header: 'Site Id',
        columns: [
          {
            accessor: UpdateOpenOrdersEnum.SiteId,
            ...ReactTableWrapperColumnProperties,
            sortable: false,
            Filter: this.filterData,
          },
        ],
      },
      {
        Header: 'Site Description',
        columns: [
          {
            accessor: UpdateOpenOrdersEnum.SiteDescription,
            ...ReactTableWrapperColumnProperties,
            sortable: false,
            Filter: this.filterData,
          },
        ],
      },
      {
        Header: 'WO #',
        columns: [
          {
            accessor: UpdateOpenOrdersEnum.OrderNumber,
            className: 'right-align',
            ...ReactTableWrapperColumnProperties,
            show: false,
            sortable: false,
            Filter: this.filterData,
          },
        ],
      },
      {
        Header: 'KO #',
        columns: [
          {
            accessor: UpdateOpenOrdersEnum.OrderNumber,
            className: 'right-align',
            ...ReactTableWrapperColumnProperties,
            show: false,
            sortable: false,
            Filter: this.filterData,
          },
        ],
      },
      {
        Header: 'Order #',
        columns: [
          {
            accessor: UpdateOpenOrdersEnum.OrderNumber,
            className: 'right-align',
            ...ReactTableWrapperColumnProperties,
            show: true,
            sortable: false,
            Filter: this.filterData,
          },
        ],
      },
      {
        Header: 'Add Qty',
        columns: [
          {
            Header: 'Purchase',
            accessor: UpdateOpenOrdersEnum.AddQtyPrimary,
            ...ReactTableWrapperColumnProperties,
            sortable: false,
            show: false,
            Filter: this.filterData,
            Cell: ({ original }) => {
              return (
                <EditableLabel
                  label={
                    original[UpdateOpenOrdersEnum.AddQtyPrimary]
                      ? original[UpdateOpenOrdersEnum.AddQtyPrimary]
                      : ''
                  }
                  labelClassName={'qtyLabel'}
                  refData={original}
                  onChange={this.handleChangePriQty}
                  allowEdit={true}
                />
              );
            },
          },
          {
            Header: 'Pack',
            accessor: UpdateOpenOrdersEnum.AddQtySecondary,
            ...ReactTableWrapperColumnProperties,
            sortable: false,
            show: false,
            Filter: this.filterData,
            Cell: ({ original }) => {
              return this.state.selectedItem.AllowPartialOrdering ? (
                <EditableLabel
                  label={
                    original[UpdateOpenOrdersEnum.AddQtySecondary]
                      ? original[UpdateOpenOrdersEnum.AddQtySecondary]
                      : ''
                  }
                  labelClassName={'qtyLabel'}
                  refData={original}
                  onChange={this.handleChangeSecQty}
                  allowEdit={true}
                />
              ) : (
                <div style={{ height: 20 }} />
              );
            },
          },
        ],
      },
      {
        Header: 'Remove Qty',
        columns: [
          {
            Header: 'Purchase',
            accessor: UpdateOpenOrdersEnum.RemoveQtyPrimary,
            className: 'right-align',
            ...ReactTableWrapperColumnProperties,
            sortable: false,
            show: false,
            Filter: this.filterData,
          },
          {
            Header: 'Pack',
            accessor: UpdateOpenOrdersEnum.RemoveQtySecondary,
            className: 'right-align',
            ...ReactTableWrapperColumnProperties,
            sortable: false,
            show: false,
            Filter: this.filterData,
          },
        ],
      },
    ];
  };

  filterData = ({ filter, onChange }) => {
    return (
      <input
        tabIndex="-1"
        onChange={event => onChange(event.target.value)}
        value={filter ? filter.value : ''}
      />
    );
  };

  getFilterData = (newValue, prevValue, field) => {
    const {
      isTypeOptionSelected,
      itemsToBeAdded,
      itemsToBeRemoved,
      selectedDeliveryDT,
      selectedItemToAdd,
      selectedItemToRemove,
      secondaryUnitValue,
      unitValue,
      qtyPerUnit,
    } = this.state;
    const {
      resetOpenOrderTable,
      getOpenOrderData,
      setRemainingItemValue,
      selectedWarehouseKitchenId,
      selectedSiteGroupId,
      selectedKitchenId,
    } = this.props;

    let siteGroupId = selectedSiteGroupId;
    let warehouseId = selectedWarehouseKitchenId;
    let kitchenId = selectedKitchenId;
    if (field === UpdateOpenOrdersEnum.SiteGroup) {
      siteGroupId = newValue;
    }
    if (field === UpdateOpenOrdersEnum.WarehouseKitchen) {
      warehouseId = newValue;
    }
    if (field === UpdateOpenOrdersEnum.Kitchen) {
      kitchenId = newValue;
    }

    const currentTypeOpt =
      isTypeOptionSelected === TypeEnum.OpenOrders
        ? UpdateOpenOrderTypeEnum.Order
        : UpdateOpenOrderTypeEnum.Receipt;
    const ordertype =
      itemsToBeAdded && itemsToBeRemoved
        ? TypeOptionEnum.Both
        : itemsToBeAdded
          ? TypeOptionEnum.ItemToAdd
          : TypeOptionEnum.ItemToRemove;

    const selectedOrderType =
      isTypeOptionSelected === TypeEnum.OpenOrders
        ? OrderTypeEnum.OpenOrder
        : isTypeOptionSelected === TypeEnum.OpenReceipts
          ? OrderTypeEnum.OpenReceiptWO
          : OrderTypeEnum.OpenReceiptKO;

    const requestObj = {
      DeliveryDT: selectedDeliveryDT,
      SiteGroupId:
        isTypeOptionSelected === TypeEnum.OpenOrders ? siteGroupId : null,
      WarehouseKitchenId:
        isTypeOptionSelected === TypeEnum.OpenReceipts
          ? warehouseId
          : isTypeOptionSelected === TypeEnum.OpenReceiptsKO
            ? kitchenId
            : null,
      UpdateOpenOrderType: currentTypeOpt,
      UpdateOpenOrderOperationType: ordertype,
      AddItemId: selectedItemToAdd,
      RemoveItemId: selectedItemToRemove,
      OrderType: selectedOrderType,
    };
    if (
      isTypeOptionSelected &&
      selectedDeliveryDT &&
      (itemsToBeAdded || itemsToBeRemoved)
    ) {
      resetOpenOrderTable();
      getOpenOrderData(requestObj).then(() => {
        setRemainingItemValue(secondaryUnitValue, unitValue, qtyPerUnit);
      });
    }
  };

  updateReset = () => {
    const { change } = this.props;
    change(
      UpdateOpenOrdersEnum.AddItemListData,
      InitialValuesEnum.AddItemListData
    );
    change(
      UpdateOpenOrdersEnum.RemoveItemListData,
      InitialValuesEnum.RemoveItemListData
    );

    const columnCopy = this.getStateColumns();

    this.setState({
      columns: columnCopy,
      qtyPerUnit: 0,
      unitValue: '',
      secondaryUnitValue: '',
      removeItemSecUnit: '',
      removeItemPriUnit: '',
      removeItemQtyPerUnit: 0,
    });
  };
  typeOptionChange = value => {
    const { resetOpenOrderTable } = this.props;
    const columnCopy = this.getStateColumns();
    let columnHeader;
    this.updateReset();
    if (value === TypeEnum.OpenReceipts) {
      columnHeader = ColumnHeaders.WO;
    } else if (value === TypeEnum.OpenReceiptsKO) {
      columnHeader = ColumnHeaders.KO;
    } else {
      columnHeader = ColumnHeaders.Order;
    }
    const transferOrderList = _.each(columnCopy, item => {
      if (
        item.Header === ColumnHeaders.WO ||
        item.Header === ColumnHeaders.KO ||
        item.Header === ColumnHeaders.Order
      ) {
        item.columns[0].show = item.Header === columnHeader;
      }
    });

    resetOpenOrderTable();
    const orderType =
      value === TypeEnum.OpenOrders
        ? OrderTypeEnum.OpenOrder
        : value === TypeEnum.OpenReceipts
          ? OrderTypeEnum.OpenReceiptWO
          : OrderTypeEnum.OpenReceiptKO;
    this.props.getItemList(
      moment(this.state.selectedDeliveryDT).format(DATE_FORMAT_FOR_SERVER),
      orderType
    );

    this.setState({
      isTypeOptionSelected: value,
      columns: transferOrderList,
      itemsToBeAdded: false,
      itemsToBeRemoved: false,
      selectedItemToRemove: null,
      selectedItemToAdd: null,
    });
  };

  setItemToBeRemoved = (e, newValue) => {
    const columnsCopy = [...this.state.columns];
    const columns = _.each(columnsCopy, item => {
      if (item.Header === ColumnHeaders.Remove_Qty) {
        item.columns[0].show = item.Header === ColumnHeaders.Remove_Qty;
        item.columns[1].show = item.Header === ColumnHeaders.Remove_Qty;
      }
    });
    const selectedItem = this.props.itemList.find(
      item => item.ItemId === newValue
    );
    this.setState(
      {
        itemsToBeRemoved: true,
        selectedItemToRemove: newValue,
        columns: columns,
        removeItemSecUnit: selectedItem.SecondaryUnit,
        removeItemPriUnit: selectedItem.Unit,
        removeItemQtyPerUnit: selectedItem.QtyPerUnit,
      },
      () => this.getFilterData()
    );
  };
  setItemToBeAdded = (e, newValue) => {
    const columnCopy = [...this.state.columns];
    const columns = _.each(columnCopy, item => {
      if (item.Header === ColumnHeaders.Add_Qty) {
        item.columns[0].show = item.Header === ColumnHeaders.Add_Qty;
        item.columns[1].show = item.Header === ColumnHeaders.Add_Qty;
      }
    });
    const selectedItem = this.props.itemList.find(
      item => item.ItemId === newValue
    );
    this.setState(
      {
        selectedItemToAdd: newValue,
        secondaryUnitValue: selectedItem.SecondaryUnit,
        unitValue: selectedItem.Unit,
        qtyPerUnit: selectedItem.QtyPerUnit,
        columns: columns,
        itemsToBeAdded: true,
        selectedItem: selectedItem,
      },
      () => this.getFilterData()
    );
  };

  handleChangePriQty = (refData, newValue) => {
    const index = _.findIndex(this.props.openOrderDetailData, x => {
      return x.OrderNumber === refData[UpdateOpenOrdersEnum.OrderNumber];
    });
    this.handleChangeQty(index, UpdateOpenOrdersEnum.AddQtyPrimary, newValue);
  };

  handleChangeSecQty = (refData, newValue) => {
    const index = _.findIndex(this.props.openOrderDetailData, x => {
      return x.OrderNumber === refData[UpdateOpenOrdersEnum.OrderNumber];
    });
    this.handleChangeQty(index, UpdateOpenOrdersEnum.AddQtySecondary, newValue);
  };

  handleChangeQty = (index, col, val) => {
    const { changeValue, calculateRemainingQty } = this.props;
    const {
      qtyPerUnit,
      unitValue,
      secondaryUnitValue,
      isTypeOptionSelected,
    } = this.state;
    const newValue = val.match(/\d{0,6}(\.\d{0,3})?/)[0];
    const orderType =
      isTypeOptionSelected === TypeEnum.OpenOrders
        ? TypeEnum.OpenOrders
        : TypeEnum.OpenReceipts;
    changeValue(index, col, newValue, qtyPerUnit, orderType);
    calculateRemainingQty(
      index,
      col,
      newValue,
      qtyPerUnit,
      unitValue,
      secondaryUnitValue,
      isTypeOptionSelected
    );
  };

  itemOptions = data => {
    if (data && Array.isArray(data) && data.length) {
      return data.map(item => ({
        value: item.ItemId,
        key: item.ItemId,
        text: `${item.ItemCode} - ${item.ItemDescription}`,
      }));
    } else {
      return [];
    }
  };

  clearFilters = () => {
    const {
      resetOpenOrderTable,
      reset,
      changeDropDownData,
      warehouseKitchenData,
      kitchenData,
    } = this.props;
    this.setState({
      itemsToBeRemoved: false,
      itemsToBeAdded: false,
      selectedItemToRemove: '',
      selectedItemToAdd: '',
      isTypeOptionSelected: TypeEnum.OpenOrders,
      selectedDeliveryDT: moment().format(DATE_FORMAT_FOR_UI),
      columns: this.getStateColumns(),
      filtered: [],
      sorted: [],
    });
    resetOpenOrderTable();
    reset();
    const warehouseOptions = makeOptionsDataRemoveEmpty(warehouseKitchenData);
    warehouseOptions.length &&
      changeDropDownData(
        UpdateOpenOrdersEnum.WarehouseKitchen,
        warehouseOptions[0].value
      );
    const kitchenOptions = makeOptionsDataRemoveEmpty(kitchenData);
    kitchenOptions.length &&
      changeDropDownData(UpdateOpenOrdersEnum.Kitchen, kitchenOptions[0].value);
  };

  onChangeOfToDT = (e, deliveryDate) => {
    this.selectToDate(e, deliveryDate);
  };

  selectToDate = (e, deliveryDate) => {
    this.setState(
      {
        selectedDeliveryDT: moment(deliveryDate).format(DATE_FORMAT_FOR_SERVER),
      },
      () => this.getFilterData()
    );
    const orderType =
      this.state.isTypeOptionSelected === TypeEnum.OpenOrders
        ? OrderTypeEnum.OpenOrder
        : this.state.isTypeOptionSelected === TypeEnum.OpenReceipts
          ? OrderTypeEnum.OpenReceiptWO
          : OrderTypeEnum.OpenReceiptKO;
    this.props.getItemList(
      moment(deliveryDate).format(DATE_FORMAT_FOR_SERVER),
      orderType
    );
  };

  onChangeOfSelectDropDown = (e, newValue, prevValue, field) => {
    this.getFilterData(newValue, prevValue, field);
  };

  onChangeOfWarehouseKitchen = (newValue, prevValue, field) => {
    this.getFilterData(newValue, prevValue, field);
  };

  onOkClick = () => {
    this.props.setShowFlag();
  };

  handleClick = (e, titleProps) => {
    const { index } = titleProps;
    const { activeIndexForFilter } = this.state;
    const newIndex = activeIndexForFilter === index ? -1 : index;
    this.setState({
      activeIndexForFilter: newIndex,
    });
  };
  onSortedChange = (sorted, column, shiftKey) => {
    this.setState({ sorted });
  };
  onFilteredChange = (filtered, column) => {
    this.setState({ filtered });
  };

  render() {
    const viewTypeOptions = [
      { value: TypeEnum.OpenOrders, label: 'Open Orders' },
      { value: TypeEnum.OpenReceipts, label: 'Open Receipts (WO)' },
      { value: TypeEnum.OpenReceiptsKO, label: 'Open Receipts (KO)' },
    ];

    const {
      openOrderDetailData,
      isFetchingSiteGroup,
      onSubmit,
      itemList,
      loading,
      isFetchingItemList,
      totalPrimary,
      totalSecondary,
      WarehouseAvlbQuantity,
      totalRemaining,
      isTotalExceed,
      siteGroupData,
      warehouseKitchenData,
      reactTableRef,
      kitchenData,
    } = this.props;

    const {
      columns,
      isTypeOptionSelected,
      unitValue,
      secondaryUnitValue,
      qtyPerUnit,
      removeItemSecUnit,
      removeItemPriUnit,
      removeItemQtyPerUnit,
      itemsToBeAdded,
      itemsToBeRemoved,
    } = this.state;
    const siteGroupsOptions = getSiteGroupOptionsData(siteGroupData);

    return (
      <UpdateOpenOrderComponent
        openOrderDetailData={openOrderDetailData}
        onSubmit={onSubmit}
        viewTypeOptions={viewTypeOptions}
        siteGroupsOptions={siteGroupsOptions}
        warehouseKitchenData={warehouseKitchenData}
        itemList={itemList}
        loading={loading}
        isFetchingItemList={isFetchingItemList}
        isFetchingSiteGroup={isFetchingSiteGroup}
        columns={columns}
        isTypeOptionSelected={isTypeOptionSelected}
        totalPrimary={totalPrimary}
        totalSecondary={totalSecondary}
        WarehouseAvlbQuantity={WarehouseAvlbQuantity}
        totalRemaining={totalRemaining}
        unitValue={unitValue}
        secondaryUnitValue={secondaryUnitValue}
        qtyPerUnit={qtyPerUnit}
        removeItemSecUnit={removeItemSecUnit}
        removeItemPriUnit={removeItemPriUnit}
        removeItemQtyPerUnit={removeItemQtyPerUnit}
        itemOptions={this.itemOptions}
        typeOptionChange={this.typeOptionChange}
        onChangeOfToDT={this.onChangeOfToDT}
        onChangeOfSelectDropDown={this.onChangeOfSelectDropDown}
        setItemToBeRemoved={this.setItemToBeRemoved}
        setItemToBeAdded={this.setItemToBeAdded}
        isTotalExceed={isTotalExceed}
        onOkClick={this.onOkClick}
        clearFilters={this.clearFilters}
        itemsToBeAdded={itemsToBeAdded}
        itemsToBeRemoved={itemsToBeRemoved}
        activeIndexForFilter={this.state.activeIndexForFilter}
        handleClick={this.handleClick}
        onChangeOfWarehouseKitchen={this.onChangeOfWarehouseKitchen}
        onSortedChange={this.onSortedChange}
        onFilteredChange={this.onFilteredChange}
        sorted={this.state.sorted}
        filtered={this.state.filtered}
        reactTableRef={reactTableRef}
        kitchenData={kitchenData}
      />
    );
  }
}

const selector = formValueSelector(UPDATE_OPEN_ORDERS_FORM_NAME);
const mapStateToProps = state => {
  return {
    initialValues: {
      [UpdateOpenOrdersEnum.DeliveryDT]: moment().format(DATE_FORMAT_FOR_UI),
      [UpdateOpenOrdersEnum.TypeOptions]: TypeEnum.OpenOrders,
      [UpdateOpenOrdersEnum.SiteGroup]: InitialValuesEnum.SiteGroup,
      [UpdateOpenOrdersEnum.WarehouseKitchen]:
        InitialValuesEnum.WarehouseKitchen,
      [UpdateOpenOrdersEnum.Kitchen]: InitialValuesEnum.Kitchen,
    },
    openOrderDetailData: Selectors.getOpenOrderDetailData(state),
    siteGroupData: Selectors.getSiteGroup(state),
    warehouseKitchenData: Selectors.getWarehouseKitchen(state),
    itemList: Selectors.getItemListData(state),
    loading: Selectors.getLoadingStatus(state),
    isFetchingItemList: Selectors.getIsFetchingItemList(state),
    isFetchingSiteGroup: Selectors.getIsFetchingSiteGroup(state),
    submitting: Selectors.getSubmitting(state),
    totalPrimary: Selectors.getTotalPrimary(state),
    totalSecondary: Selectors.getTotalSecondary(state),
    totalRemaining: Selectors.geTotalRemaining(state),
    WarehouseAvlbQuantity: Selectors.getWarehouseAvlbQuantity(state),
    isTotalExceed: Selectors.getIsTotalExceed(state),
    kitchenData: Selectors.getKitchenData(state),
    selectedWarehouseKitchenId: selector(
      state,
      UpdateOpenOrdersEnum.WarehouseKitchen
    ),
    selectedSiteGroupId: selector(state, UpdateOpenOrdersEnum.SiteGroup),
    selectedKitchenId: selector(state, UpdateOpenOrdersEnum.Kitchen),
  };
};

UpdateOpenOrderDetailsContainer = reduxForm({
  enableReinitialize: true,
  destroyOnUnmount: false,
  form: UPDATE_OPEN_ORDERS_FORM_NAME,
})(UpdateOpenOrderDetailsContainer);

export const UpdateOpenOrderDetails = connect(
  mapStateToProps,
  {
    ...actions,
    resetForm,
  }
)(UpdateOpenOrderDetailsContainer);



// WEBPACK FOOTER //
// ./src/pages/utilities/updateopenorders/containers/UpdateOpenOrderDetails.js